'use strict';

/* globals window */

window.STORYBOOK_REACT_CLASSES = {};
window.STORYBOOK_ENV = 'react';